const aws_ip = "34.225.137.137";
// Force localhost for DEV to prevent AWS IP usage
const local_ip = "localhost";

module.exports = {
  OPENAI: {
    OPENAI_KEY: process.env.REACT_APP_OPENAI_KEY
  },
  AWS: {
    S3_BUCKET_NAME: process.env.REACT_APP_S3_BUCKET_NAME,
    S3_REGION: process.env.REACT_APP_S3_REGION,
    AWS_ACCESS_KEY_ID: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    AWS_SECRET_ACCESS_KEY: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  },
  PROD: {
    baseURL: `/api2/v1`,
    baseURLSchemas: `/api/schemas`,
    baseURLSaveUUID: `/api/save_uuids`,
    baseURLSaveJob: `/api/save_job`,
    baseURLGetJobs: `/api/jobs`,
    baseURLGetSchema: `/api/get_schema`,
    baseURLGetDest: `/api/get_destinations`,
    baseURLGetDoc: `/api/get_doc`,
    baseURLGetGLN: `/api/get_gln`,
    baseURLGetGLNS: `/api/get_glns`,
    baseURLGetDoc2: `/api/get_doc2`,
    dropMeJobs: `/api/jobs`,
    dropMeJobs3: `/api/jobs3`,
    baseURLGetLocUUID: `/api/get_uuid_loc`,
    dropMeJobsXLSX: `/api/jobs_xlsx`,
    dropMeJobsOCR: `/api/jobs_ocr`,
    dropMeJobsTXT: `/api/jobs_txt`,
    manuProdCount: `/api/get_prod_count`,
    manuJobs: `/api/jobs`,
    logging: `/api/get_logs`,
    connections: `/api/get_connections`,
    rename_files: `/api/rename_files`,
    create_presigned_url: `/api/create_presigned_url`,
    baseURLGetGS1: `/api/get_gtin`,
    baseURLGetProducts: `/api/get_products`,
    baseURLGetS3: `/api/list_s3_buckets`,
    baseURLJIRA: `/api/create_record_in_jira`,
    baseURLUpdateJobLOC: `/api/update_job_loc`,
    baseURLGetGTINS: `/api/get_gtins`,
    baseURLGetWalmartLogs: `/api/get_walmart_logs`,
    baseURLGetShopifyLogs: `/api/get_shopify_logs`,
    baseURLGetGDSNLogs: `/api/get_gdsn_logs`,
    baseURLSavePDFForOpenAI: `/api/save_pdf_files_for_openai`,
    baseURLGetOpenAIQueuePDF: `/api/get_openai_queue_pdf`,
    baseURLGeneratePresignedURL: `/api/generate_presigned_url`,
    baseURLGenerateSignedURLs: `/api/generate_signed_urls`,
    baseURLOpenAIGetDataPDF: `/api/openai_get_data_pdf`,
    baseURLSavePDFToMongo: `/api/save_pdf_to_mongo`,
    baseURLGetPDFDocs: `/api/get_pdf_openai_document`,
    baseURLGetAllPDFDocs: `/api/get_all_pdf_openai_document`,
    baseURLAddPhotoToS3: `/api/add_photo_to_s3`,
    baseURLProcessImagesForIngredients: `/api/process_images_for_ingredients`,
    baseURLUpdateProduct: `/api/update_product`,
    baseURLDeleteProduct: `/api/delete_product_record`,
    baseURLFetchGS1GTIN: `/api/get_gtin_from_gs1`,
    baseURLPublishPDF: `/api/publish_pdf`,
    baseURLAddCustomFields: `/api/add_custom_field`,
    baseURLGetCustomFields: `/api/get_custom_fields`,
    baseURLDeleteCustomFields: `/api/delete_custom_field`,
    baseURLUpdateCustomField: `/api/update_custom_field`,
    baseURLUpdateSchemas: `/api/updateSchemas`,
    baseURLUpdateProductCell: `/api/update_product_cell`,
    baseURLSavePublishReports: `/api/save_publish_reports`,
    baseURLSearchDataHub: `/api/search_data_hub`,
    baseURLGetPublishedReports: `/api/get_publish_reports`,
    baseURLGetFieldLists: `/api/get_field_lists`,
    baseURLDeleteFieldLists: `/api/delete_field_list`,
    baseURLUpdateFieldLists: `/api/update_field_list`,
    baseURLSaveFieldLists: `/api/save_field_list`,
    baseURLDeleteS3File: `/api/delete_s3_file`,
    baseURLDeleteS3FilesBulk: `/api/delete_s3_files_bulk`,
    baseURLDeleteProductsBulk: `/api/delete_products_bulk`,
    baseURLGetAIFieldLogic: `/api/get_ai_field_logic`,
    baseURLCreateAIFieldLogic: `/api/create_ai_field_logic`,
    baseURLUpdateAIFieldLogic: `/api/update_ai_field_logic`,
    baseURLDeleteAIFieldLogic: `/api/delete_ai_field_logic`,
    baseURLReplaceDuplicate: `/api/replace_duplicate_document`,
    baseURLGetPublishedJobIds: `/api/get_published_job_ids`,
    baseURLRenamePublishedOutputs: `/api/rename_published_outputs`,
    baseURLDeletePublishReport: `/api/delete_publish_report`,
  },
  DEV: {
    baseURL: `http://localhost:2031/api/v1`,
    baseURLSchemas: `http://${local_ip}:5051/api/schemas`,
    baseURLSaveUUID: `http://${local_ip}:5051/api/save_uuids`,
    baseURLGetLocUUID: `http://${local_ip}:5051/api/get_uuid_loc`,
    baseURLSaveJob: `http://${local_ip}:5051/api/save_job`,
    baseURLGetJobs: `http://${local_ip}:5051/api/jobs`,
    baseURLGetSchema: `http://${local_ip}:5051/api/get_schema`,
    baseURLGetDest: `http://${local_ip}:5051/api/get_destinations`,
    baseURLGetDoc: `http://${local_ip}:5051/api/get_doc`,
    baseURLGetDoc2: `http://${local_ip}:5051/api/get_doc2`,
    dropMeJobs: `http://${local_ip}:5051/api/jobs`,
    dropMeJobs3: `http://${local_ip}:5051/api/jobs3`,
    dropMeJobsXLSX: `http://${local_ip}:5051/api/jobs_xlsx`,
    dropMeJobsOCR: `http://${local_ip}:5051/api/jobs_ocr`,
    manuProdCount: `http://${local_ip}:5051/api/get_prod_count`,
    manuJobs: `http://${local_ip}:5051/api/jobs`,
    logging: `http://${local_ip}:5051/api/get_logs`,
    connections: `http://${local_ip}:5051/api/get_connections`,
    rename_files: `http://${local_ip}:5051/api/rename_files`,
    dropMeJobsTXT: `http://${local_ip}:5051/api/jobs_txt`,
    create_presigned_url: `http://${local_ip}:5051/api/create_presigned_url`,
    baseURLGetGS1: `http://${local_ip}:5051/api/get_gtin`,
    baseURLGetProducts: `http://${local_ip}:5051/api/get_products`,
    baseURLGetS3: `http://${local_ip}:5051/api/list_s3_buckets`,
    baseURLJIRA: `http://${local_ip}:5051/api/create_record_in_jira`,
    baseURLGetGLN: `http://${local_ip}:5051/api/get_gln`,
    baseURLGetGLNS: `http://${local_ip}:5051/api/get_glns`,
    baseURLUpdateJobLOC: `http://${local_ip}:5051/api/update_job_loc`,
    baseURLGetGTINS: `http://${local_ip}:5051/api/get_gtins`,
    baseURLGetWalmartLogs: `http://${local_ip}:5051/api/get_walmart_logs`,
    baseURLGetShopifyLogs: `http://${local_ip}:5051/api/get_shopify_logs`,
    baseURLGetGDSNLogs: `http://${local_ip}:5051/api/get_gdsn_logs`,
    baseURLSavePDFForOpenAI: `http://${local_ip}:5051/api/save_pdf_files_for_openai`,
    baseURLGetOpenAIQueuePDF: `http://${local_ip}:5051/api/get_openai_queue_pdf`,
    baseURLGeneratePresignedURL: `http://${local_ip}:5051/api/generate_presigned_url`,
    baseURLGenerateSignedURLs: `http://${local_ip}:5051/api/generate_signed_urls`,
    baseURLOpenAIGetDataPDF: `http://${local_ip}:5051/api/openai_get_data_pdf`,
    baseURLSavePDFToMongo: `http://${local_ip}:5051/api/save_pdf_to_mongo`,
    baseURLGetPDFDocs: `http://${local_ip}:5051/api/get_pdf_openai_document`,
    baseURLGetAllPDFDocs: `http://${local_ip}:5051/api/get_all_pdf_openai_document`,
    baseURLAddPhotoToS3: `http://${local_ip}:5051/api/add_photo_to_s3`,
    baseURLProcessImagesForIngredients: `http://${local_ip}:5051/api/process_images_for_ingredients`,
    baseURLUpdateProduct: `http://${local_ip}:5051/api/update_product`,
    baseURLDeleteProduct: `http://${local_ip}:5051/api/delete_product_record`,
    baseURLFetchGS1GTIN: `http://${local_ip}:5051/api/get_gtin_from_gs1`,
    baseURLPublishPDF: `http://${local_ip}:5051/api/publish_pdf`,
    baseURLSearchDataHub: `http://${local_ip}:5051/api/search_data_hub`,
    baseURLAddCustomFields: `http://${local_ip}:5051/api/add_custom_field`,
    baseURLGetCustomFields: `http://${local_ip}:5051/api/get_custom_fields`,
    baseURLDeleteCustomFields: `http://${local_ip}:5051/api/delete_custom_field`,
    baseURLUpdateCustomField: `http://${local_ip}:5051/api/update_custom_field`,
    baseURLUpdateSchemas: `http://${local_ip}:5051/api/updateSchemas`,
    baseURLUpdateProductCell: `http://${local_ip}:5051/api/update_product_cell`,
    baseURLSavePublishReports: `http://${local_ip}:5051/api/save_publish_reports`,
    baseURLGetPublishedReports: `http://${local_ip}:5051/api/get_publish_reports`,
    baseURLGetFieldLists: `http://${local_ip}:5051/api/get_field_lists`,
    baseURLDeleteFieldLists: `http://${local_ip}:5051/api/delete_field_list`,
    baseURLUpdateFieldLists: `http://${local_ip}:5051/api/update_field_list`,
    baseURLSaveFieldLists: `http://${local_ip}:5051/api/save_field_list`,
    baseURLDeleteS3File: `http://${local_ip}:5051/api/delete_s3_file`,
    baseURLDeleteS3FilesBulk: `http://${local_ip}:5051/api/delete_s3_files_bulk`,
    baseURLDeleteProductsBulk: `http://${local_ip}:5051/api/delete_products_bulk`,
    baseURLGetAIFieldLogic: `http://${local_ip}:5051/api/get_ai_field_logic`,
    baseURLCreateAIFieldLogic: `http://${local_ip}:5051/api/create_ai_field_logic`,
    baseURLUpdateAIFieldLogic: `http://${local_ip}:5051/api/update_ai_field_logic`,
    baseURLDeleteAIFieldLogic: `http://${local_ip}:5051/api/delete_ai_field_logic`,
    baseURLReplaceDuplicate: `http://${local_ip}:5051/api/replace_duplicate_document`,
    baseURLGetPublishedJobIds: `http://${local_ip}:5051/api/get_published_job_ids`,
    baseURLRenamePublishedOutputs: `http://${local_ip}:5051/api/rename_published_outputs`,
    baseURLDeletePublishReport: `http://${local_ip}:5051/api/delete_publish_report`,
  },
};
